module.exports = __webpack_public_path__ + "static/media/2020 Convention bookstore script final_1595861721632.ef1dc953.pdf";